import React from 'react';
import Modal from 'src/app/components/Modal';
import { t } from 'i18next';

export default function CreationGroupsModal(props) {
  const { show, onClose, handleSubmit, form } = props;

  return (
    <Modal
      show={show}
      onClose={onClose}
      contentClassName="modal__content--md"
    >
      <h3 className="modal__simple-title">{t('textsCommon.participantDistribution')}</h3>

      <div
        className="kpi-widget kpi-widget--bright mb-4"
        style={{ width: '80%' }}
      >
        <div className="kpi-widget__header">
          <span className="kpi-widget__hat">Projeto</span>
          <p className="kpi-widget__action-title">{form?.values?.title}</p>
          <h4 className="kpi-widget__count">{form?.values?.students?.length} grupos</h4>
        </div>

        <div>
          <div className="kpi-widget__count-in-body mb-2">
            {form?.values?.students?.length} grupos{' '}
            <span>
              com {form?.values?.groupSize} {t('sideBar.participants')}
            </span>
          </div>
          <div className="kpi-widget__count-in-body">
            {form?.values?.managers?.length} {t('courses.managers')}
          </div>
        </div>
      </div>

      <p>Você confirma a criação dos grupos para o projeto?</p>

      <div className="card__columns">
        <button
          type="button"
          className="btn btn--outline btn--full"
          onClick={onClose}
        >
          Não
        </button>
        <button
          type="button"
          className="btn btn--primary btn--full"
          onClick={() => handleSubmit()}
        >
          Sim
        </button>
      </div>
    </Modal>
  );
}
